import React from "react";
import {Job as JobType} from "./Job.types";

type Props = {
    job: JobType
}

const JobRow: React.FC<Props> = ({job}) => {
    return (
        job.visible ?
            <a className="job-row" href={job.detailUrl} target={'_blank'} rel="noreferrer">
                <div className={'job-title'}>{job.title}</div>
                <div className={'job-infos'}>
                    <div className={'job-city'}>{job.city}</div>
                    <div className={'job-distance'}>{job.distance}</div>
                </div>
            </a>
            : <></>
    );
}

export default JobRow
